import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import 'bootstrap-icons/font/bootstrap-icons.css';

const MainMenu = ({ user }) => {
    const navigate = useNavigate();
    

    // Verificação de segurança: Se não houver token ou estiver expirado, redireciona
    useEffect(() => {
        const token = localStorage.getItem('@AutomaTech:token');
        if (!token) {
            handleLogout();

            return;
        }

        try {
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;
            
            if (decoded.exp < currentTime) {
                handleLogout(); // Token expirado
            }
        } catch (e) {
            handleLogout();
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('@AutomaTech:token');
        // Como o Login renderiza o MainMenu condicionalmente, 
        // o reload é a forma mais limpa de resetar o estado do App para a tela de login.
        window.location.reload();
    };

    // 1. Mapeamento de quais roles dão acesso a cada app
    const applications = [
        {
            id: 'app1',
            name: 'AquaTech',
            description: 'Controle remotamente o abastecimento de sua residência ou empresa e obtenha dados críticos para tomada de decições!',
            icon: 'bi-droplet-half',
            path: '',
            requiredRoles: ['AQT_ROLE_ADMIN','ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app2',
            name: 'AutomaTech',
            description: 'Automatize processos de sua empresa que exigem cuidado, atenção e não podem ter erros. Leitura de notas fiscais, extração de dados, conversão de/para XML e muito mais!',
            icon: 'bi-magic',
            path: '',
            requiredRoles: ['ATM_ROLE_ADMIN','ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app2',
            name: 'ManuTech',
            description: 'Mantenha fiel registro das manutenções do seu Carro e da sua Residência ou Empresa, aumente o controle e o preço de revenda!',
            icon: 'bi-tools',
            path: '',
            requiredRoles: ['MNT_ROLE_ADMIN','ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app3',
            name: 'MenuTech',
            description: 'Crie e edite você mesmo o Cardápio online de seu restaurante, sem intermediários e de onde estiver!',
            icon: 'bi-book',
            path: '',
            requiredRoles: ['MEN_ROLE_ADMIN', 'ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app4',
            name: 'PresenTech',
            description: 'Crie e compartilhe com os amigos sua lista de presentes e desejos e se surpreenda com as pessoas que secretamente irão realizar seus sonhos!',
            icon: 'bi-gift',
            path: '',
            requiredRoles: ['PST_ROLE_ADMIN','ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app5',
            name: 'AjudaTech!',
            description: 'O que é isso? Porquê tudo é Tech? Como compro uma licença? Socorro!',
            icon: 'bi-question-circle',
            path: '',
            requiredRoles: ['AQT_ROLE_ADMIN','ATM_ROLE_ADMIN','MEN_ROLE_ADMIN','MNT_ROLE_ADMIN','PST_ROLE_ADMIN','ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app6',
            name: 'Termos de Serviço',
            description: 'Ao acessar esta Suíte de Aplicações, você declara concordar com estes Termos',
            icon: 'bi-file-earmark-text',
            path: '',
            requiredRoles: ['AQT_ROLE_ADMIN','ATM_ROLE_ADMIN','MEN_ROLE_ADMIN','MNT_ROLE_ADMIN','PST_ROLE_ADMIN','ROLE_DEVELOPER','ROLE_ENGINEER']
        },
        {
            id: 'app7',
            name: 'Manutenção - Acesso Restrito',
            description: 'Acesso do Desenvolvedor para manutenção e comandos especiais',
            icon: 'bi-gear-wide-connected',
            path: '',
            requiredRoles: ['ROLE_ENGINEER']
        }
    ];

    // 2. Função auxiliar para verificar permissão
    const hasAccess = (requiredRoles) => {
        if (!user?.roles) return false;
        // Se roles for uma string única (ex: "ADMIN"), transforma em array para comparar
        const userRolesArray = Array.isArray(user.roles) ? user.roles : [user.roles];
        return requiredRoles.some(role => userRolesArray.includes(role));
    };

    return (
        <div className="container py-5">
            <div className="d-flex justify-content-between align-items-center mb-5">
                <div>
                    <span className="badge bg-light text-dark border me-2">ID: {user?.userId}</span>
                    <span className="badge bg-primary">Perfil: {user?.roles}</span>
                </div>
                <button className="btn btn-outline-danger btn-sm fw-bold" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right me-2"></i>SAIR
                </button>
            </div>

            <div className="row justify-content-center text-center">
                <div className="col-12 col-md-10 col-lg-8 mb-5">
                    <h1 className="display-4 fw-bold text-primary">PhantomTech Apps</h1>
                    <p className="lead text-muted">
                        Selecione o app desejado, disponível conforme vigência de sua licença.
                        As licenças são adquiridas separadamente pelo período contratado, conforme sua necessidade.
                    </p>
                </div>

                <div className="row g-4 justify-content-center">
                    {applications.map((app) => {
                        const active = hasAccess(app.requiredRoles); // Verifica se está ativo

                        return (
                            <div key={app.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <div
                                    className={`card h-100 shadow-sm border-0 text-center p-3`}
                                    onClick={() => active && navigate(app.path)}
                                    style={{
                                        cursor: active ? 'pointer' : 'not-allowed',
                                        transition: '0.3s',
                                        borderRadius: '12px',
                                        // Mantemos o fundo e escala de cinza apenas no container do card
                                        backgroundColor: active ? '#fff' : '#f8f9fa',
                                        filter: active ? 'none' : 'grayscale(100%)',
                                        opacity: active ? '1' : '0.7'
                                    }}


                                    onMouseEnter={(e) => {
                                        if (active) {
                                            e.currentTarget.style.transform = 'translateY(-8px)';
                                            e.currentTarget.style.boxShadow = '0 1rem 3rem rgba(0,0,0,0.175)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (active) {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)';
                                        }
                                    }}
                                >
                                    <div className="card-body d-flex flex-column align-items-center justify-content-center">
                                        <i className={`bi ${app.icon} display-5 mb-3 ${active ? 'text-primary' : 'text-secondary'}`}></i>
                                        <h5 className={`card-title fs-6 fw-bold mb-2 ${active ? 'text-dark' : 'text-muted'}`}>{app.name}</h5>

                                        {/* ALTERAÇÃO AQUI: A descrição agora é sempre visível e com cor padrão */}
                                        <p className="card-text text-dark mb-0" style={{ fontSize: '0.8rem', lineHeight: '1.2' }}>
                                            {app.description}
                                        </p>
                                        {!active && (
                                            <span className="badge bg-secondary mt-2" style={{ fontSize: '0.7rem' }}>Bloqueado</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );



                    })}
                </div>
            </div>
        </div>
    );
};

export default MainMenu;